module.exports = __webpack_public_path__ + "assets/img/logo1.018febe6.png";